export const PLATFORM_NAME = 'Portafino Dashboard'
